"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Explorer = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var event_tracker_types_1 = require("@qwilr/event-tracker-types");
var CensusCollector_1 = require("Onboarding/CensusCollector/CensusCollector");
var styles = __importStar(require("./Explorer.css"));
var Transitions_1 = require("Onboarding/CensusCollector/Common/Transitions");
var inversify_react_1 = require("inversify-react");
var Types_1 = require("TemplatesGallery/Types");
var Explorer = function (_a) {
    var onComplete = _a.onComplete;
    var onboardingTelemetryService = (0, inversify_react_1.useInjection)("onboardingTelemetryService");
    var dataStore = (0, inversify_react_1.useInjection)("censusCollectorStore");
    var goToEditor = function () {
        onboardingTelemetryService.onboardingStepCompleted(event_tracker_types_1.OnboardingStepName.Explorer, {
            explorerOptionChosen: event_tracker_types_1.OnboardingExplorerOption.Editor,
        });
        dataStore.completionData = { landingPoint: CensusCollector_1.ChosenLandingPoint.Editor };
        onComplete();
    };
    var goToTemplateGallery = function () {
        onboardingTelemetryService.onboardingStepCompleted(event_tracker_types_1.OnboardingStepName.Explorer, {
            explorerOptionChosen: event_tracker_types_1.OnboardingExplorerOption.TemplateGallery,
        });
        dataStore.completionData = { landingPoint: CensusCollector_1.ChosenLandingPoint.TemplateGallery, tab: Types_1.TabName.Explore };
        onComplete();
    };
    var skipToDashboard = function () {
        onboardingTelemetryService.onboardingStepCompleted(event_tracker_types_1.OnboardingStepName.Explorer, {
            explorerOptionChosen: event_tracker_types_1.OnboardingExplorerOption.Dashboard,
        });
        dataStore.completionData = { landingPoint: CensusCollector_1.ChosenLandingPoint.Dashboard };
        onComplete();
    };
    return (react_1.default.createElement("div", { className: styles.root },
        react_1.default.createElement(Transitions_1.FadeInTransition, { timeout: 500 },
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs" },
                react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", align: "center", strong: true }, "How would you like to start?"),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "l", align: "center" }, "Choose what you want to do first in Qwilr"))),
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.grid, direction: "horizontal", gap: "s" },
            react_1.default.createElement(Transitions_1.FadeInTransition, { timeout: 1000 },
                react_1.default.createElement(kaleidoscope_1.ButtonCard, { className: styles.card, onClick: goToEditor },
                    react_1.default.createElement("img", { className: styles.cardImage, src: "Assets/Images/onboarding/chooseEntryPoint/proposal.png", width: 566, height: 400 }),
                    react_1.default.createElement(kaleidoscope_1.Heading, { className: styles.cardTitle, level: "4", align: "center", strong: true }, "Create my own proposal"))),
            react_1.default.createElement(Transitions_1.FadeInTransition, { timeout: 1100 },
                react_1.default.createElement(kaleidoscope_1.ButtonCard, { className: styles.card, onClick: goToTemplateGallery },
                    react_1.default.createElement("img", { className: styles.cardImage, src: "Assets/Images/onboarding/chooseEntryPoint/templates.png", width: 566, height: 400 }),
                    react_1.default.createElement(kaleidoscope_1.Heading, { className: styles.cardTitle, level: "4", align: "center", strong: true }, "Browse templates")))),
        react_1.default.createElement(Transitions_1.FadeInTransition, { timeout: 1500 },
            react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Medium, onClick: skipToDashboard }, "Explore Qwilr on my own"))));
};
exports.Explorer = Explorer;
